import { createUseStyles } from 'react-jss';
import spacing from '../../../utils/spacing.js';

var styles = createUseStyles({
  List: {
    counterReset: 'item',
    display: 'block',
    listStylePosition: ({
      position
    }) => position,
    padding: ({
      theme,
      padding
    }) => spacing(theme, padding) || 0,
    margin: ({
      theme,
      margin
    }) => spacing(theme, margin) || 0,
    listStyleType: ({
      listType
    }) => listType === 'nested' ? 'none' : listType,
    '& li': {
      display: ({
        listType
      }) => listType === 'nested' ? 'block' : 'list',
      padding: 0,
      marginBottom: ({
        theme,
        spacing
      }) => theme.spacing[spacing] || spacing,
      '&:before': {
        content: ({
          listType
        }) => listType === 'nested' ? 'counters(item, ".") " "' : ''
      }
    },
    '& li $List': {
      marginTop: ({
        theme,
        spacing
      }) => theme.spacing[spacing] || spacing,
      marginLeft: ({
        theme,
        indent
      }) => theme.spacing[indent] || indent || ''
    },
    '& > li': {
      counterIncrement: 'item'
    }
  },
  Type: ({
    theme,
    color,
    font,
    weight
  }) => ({
    color: theme.colors[color],
    ...theme.typography[font],
    fontWeight: weight || 'normal'
  })
});

export { styles as default };
